import { useReducer } from "react";

const CreateStore = (reducer, initialState) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    return { state, dispatch };
};

export default CreateStore;
